import clsx from 'clsx';
import { Check, CheckCheck } from 'lucide-react';
import { formatDate } from '@utils/formatters';
import type { Message } from '@/types';

interface MessageBubbleProps {
  message: Message;
  isOwn: boolean;
}

export function MessageBubble({ message, isOwn }: MessageBubbleProps) {
  const isRead = message.status === 'read' || message.isRead;

  return (
    <div className={clsx('flex', isOwn ? 'justify-end' : 'justify-start')}>
      <div
        className={clsx(
          'max-w-[85%] rounded-2xl px-3.5 py-2.5 shadow-sm',
          isOwn
            ? 'rounded-br-md bg-brand-500 text-white'
            : 'rounded-bl-md border border-slate-200 bg-white text-slate-800',
        )}
      >
        <p className="whitespace-pre-wrap break-words text-sm leading-relaxed">{message.content}</p>
        <div
          className={clsx(
            'mt-1.5 flex items-center justify-end gap-1 text-[10px]',
            isOwn ? 'text-white/80' : 'text-slate-400',
          )}
        >
          <span>{formatDate(message.createdAt)}</span>
          {isOwn &&
            (isRead ? (
              <CheckCheck className="h-3.5 w-3.5 text-sky-200" aria-label="Okundu" />
            ) : (
              <Check className="h-3.5 w-3.5" aria-label="İletildi" />
            ))}
        </div>
      </div>
    </div>
  );
}
